import { render } from "./NavView.vue?vue&type=template&id=ef4bdbc4&scoped=true"
const script = {}

import "./NavView.vue?vue&type=style&index=0&id=ef4bdbc4&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4bdbc4"]])

export default __exports__